import React from 'react'
import { Modal, ModalBody } from 'reactstrap'
import PropTypes from 'prop-types'

import Button from '../Button'

const AlertModal = ({ isOpen, toggle, button, children, icon, size = 'sm', title }) => {
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} contentClassName='rounded' size={size}>
        <ModalBody className='text-center'>
          <div className='mb-3'>{icon}</div>
          <p className='mb-4 h5'>{title}</p>
          <div className='mb-4'>{children}</div>
          {button}
          <Button block className='btn-link' type='button' onClick={toggle}>Cancel</Button>
        </ModalBody>
      </Modal>
    </div>
  )
}

AlertModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  button: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  icon: PropTypes.element,
  size: PropTypes.string,
  title: PropTypes.string
}

export default AlertModal
